import React, { FC, memo, MouseEventHandler, useCallback } from "react";
import classnames from "classnames";

type IOwnProps = {
    id?: string;
    checked?: boolean;
    onClick?: MouseEventHandler<HTMLInputElement>;
    onDoubleClick?: MouseEventHandler<HTMLInputElement>;
    onChange?: (checked: boolean) => void;
};

/**
 * Fancy checkbox, which should be rendered inside AgGrid
 */
const AgCheckbox: FC<IOwnProps> = ({ checked, onClick, onDoubleClick, onChange, id }) => {
    const onClickHandler = useCallback(
        (e: React.MouseEvent<HTMLInputElement>) => {
            onChange?.(!checked);
            onClick?.(e);
        },
        [checked, onClick, onChange],
    );
    return (
        <div className="ag-selection-checkbox" role="presentation">
            <div className="ag-labeled ag-label-align-right ag-checkbox ag-input-field" role="presentation">
                <div className="ag-input-field-label ag-label ag-hidden ag-checkbox-label" role="presentation" />
                <div
                    className={classnames("ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper", {
                        "ag-checked": checked,
                    })}
                    role="presentation"
                >
                    <input
                        className="ag-input-field-input ag-checkbox-input"
                        type="checkbox"
                        id={id}
                        aria-label={`Press Space to toggle row selection (${checked ? "checked" : "unchecked"})`}
                        checked={checked}
                        onClick={onClickHandler}
                        onDoubleClick={onDoubleClick}
                        tabIndex={-1}
                        readOnly
                    />
                </div>
            </div>
        </div>
    );
};

export default memo(AgCheckbox);
